import { AddressEntityModel } from './AddressEntityModel';
import { ContactEntityModel } from './ContactEntityModel';

export class WaiterEntityModel {
    constructor(u) {
         
        this.name = u.name;
        this.remarks=u.remarks;
        if(u.address.city|| u.country_id|| u.postal_code||u.address_line1||u.address_line2)
        {
            this.address =new AddressEntityModel(u.address)

        }
        if(u.contact && u.contact.phone || u.contact&& u.contact.telephone )
        {
            this.contact = new ContactEntityModel(u.contact);

        }

        

        
    }


}
